// Module
var code = "<div class=\"m-t\"> <machine-categories-list on-error=\"onError\" on-success=\"onSuccess\"> <machine-categories-list/> </machine-categories-list></div> ";
// Exports
var _module_exports = code;;
var path = '/admin/machines/categories.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;